import { useTranslation } from 'react-i18next';
import Google from './Google';

export default function SocialLogin() {
  const { t } = useTranslation();

  // function handleFacebookClick() {
  //   login();
  //   closeDialog();
  // }

  return (
    <div className="flex flex-col bg-white p-8 rounded-xl">
      <h3 className="text-center text-2xl mb-8 text-gray-dark">{t('SocialLogin.title')}</h3>
      {/* <button
        className="border border-1 rounded-lg border-gray flex m-2 py-2 px-4 text-gray space-x-2"
        onClick={handleFacebookClick}
      >
        <LogoFacebook />
        <span>{t('SocialLogin.signUpWithFacebook')}</span>
      </button> */}

      <Google />
    </div>
  );
}
